import React from 'react';

import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';
import { Hyperlink } from '@openedx/paragon';

import messages from './messages';

const LoginMessage = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="login-message">
      <FormattedMessage
        id="login.message.reset.password"
        defaultMessage="If you are signing in for the first time after January 12, {resetPasswordText} (look for the button below)."
        description="Message informing users to reset their password after January 12"
        values={{
          resetPasswordText: <b>{formatMessage(messages['login.message.reset.password.bold'])}</b>,
        }}
      />
      <Hyperlink
        destination="https://www.copernicuscenter.edu.pl/copernicus-college/"
        target="_blank"
        showLaunchIcon={false}
      >
        {formatMessage(messages['login.message.read.more'])}
      </Hyperlink>
    </div>
  );
};

export default LoginMessage;
